import { classNames } from 'primereact/utils'

const badge = {
    root: ({ props }: { props: any }) => ({
        className: classNames(
            // Font
            'text-sm font-bold leading-[1.5rem]',

            // Alignment
            'text-center inline-block',
            // Size
            'p-0 px-2',
            'h-[1.5rem]',
            // Shape
            'rounded-full',
            'rounded-[0.71rem]',

            // Color
            'text-allstate-navy',
            'border border-solid',
            {
                'border-allstate-blue bg-faded-blue':
                    props.severity === null || props.severity === 'primary',
                'border-warning-red bg-warning-red text-white':
                    props.severity === 'declined',
                'border-accent-green bg-accent-green':
                    props.severity === 'approved',
                'bg-faded-green border-accent-green':
                    props.severity === 'success',
                'bg-warning-yellow border-warning-yellow':
                    props.severity === 'pending',
                'bg-grey-4 border-grey-4':
                    props.severity === 'info',
                'bg-faded-red border-warning-red': props.severity === 'danger',
                'bg-faded-yellow border-warning-yellow':
                    props.severity === 'warning',
                'bg-white border-grey-4': props.severity === 'secondary',
                'bg-faded-coral border-accent-coral': props.severity === 'contrast',
            }
        ),
    }),
}

export default badge
